module.exports = __webpack_public_path__ + "static/project-1c-519cd4fa48c0a9b91ccea15dab836614.png";